import { releaseSeat, takeSeat } from '../api/portal';
import { reportError } from '../faro';

/**
 * Save or give up a seat (XN-4558), for the list and a session's page alike.
 * Says so itself when it fails. Resolves to 'saved' or 'released', 'failed'
 * when the write did not land, and 'gone' when the session is no longer the
 * viewer's to see (404), which the caller drops from view.
 */
export async function writeSeat(id, on, { series = false } = {}) {
  try {
    await (on ? takeSeat : releaseSeat)(id, { series });
    return on ? 'saved' : 'released';
  } catch (error) {
    if (error?.response?.status === 404) {
      window.loadNotification?.({ message: 'That session is no longer available.', error: true });
      return 'gone';
    }
    reportError(error);
    window.loadNotification?.({ message: "That didn't save. Try again.", error: true });
    return 'failed';
  }
}
